
import {Component, Prop, Vue} from 'vue-property-decorator';
import {bus} from "@/plugins/bus";
import CarListEmpty from "@/modules/CarList/components/CarListEmpty.vue";
import {IParkEvent} from "@/modules/ParksConfig/interfaces/park-event.interface";
import ParkEventRow from "@/modules/ParksConfig/components/ParkEvents/ParkEventRow.vue";
import type {IParksConfig} from "@/modules/ParksConfig/interfaces/parks-config.interface";

@Component({
  components: {
    ParkEventRow,
    CarListEmpty,
  },
})
export default class ParkEventsTable extends Vue {
  @Prop() park: IParksConfig.IPark;

  activeRow = null;

  get cellProps(): IParkEvent.ITableCell[] {
    return [
      { label: 'Код', prop: 'id', propType: IParkEvent.PropType.Text, },
      { label: 'Дата начала', prop: 'dateBeg', propType: IParkEvent.PropType.Date, },
      { label: 'Дата окончания', prop: 'dateEnd', propType: IParkEvent.PropType.Date, },
      { label: 'Цена часа', prop: 'tSum', propType: IParkEvent.PropType.Input, inputType: 'number', numberSymbol: '₽', },
      { label: 'Цена мероприятия', prop: 'tSumAll', propType: IParkEvent.PropType.Input, inputType: 'number', numberSymbol: '₽', },
      { label: 'Комментарий', prop: 'comment', propType: IParkEvent.PropType.Textarea, },
      { label: 'Автор', prop: 'persName', propType: IParkEvent.PropType.Text, },
      { label: 'Команды', prop: 'actions', propType: IParkEvent.PropType.Actions, },
    ];
  }

  get loading() { return this.$store.state.carList.loading; }
  get tableData() { return this.$store.state.parksConfig.parkEvents; }

  async created() {
    await this.getParkEvents();
  }

  async mounted() {
    bus.$on(IParkEvent.EmitterEvents.ActivateNewRow, () => this.activateRow(0));
  }

  async getParkEvents() {
    await this.$store.dispatch('parksConfig/getParkEvents', { parkId: this.park.id });
  }

  activateRow(index) {
    this.activeRow = index;
  }

  destroyed() {
    bus.$off(IParkEvent.EmitterEvents.ActivateNewRow);
  }
}
